import { useState } from 'react';
import { Info, ChevronDown } from 'lucide-react';

const RATINGS = [
  ['LOCK', 'bg-emerald-500 text-black', 'Our strongest ticket. Every leg is a high-% pick and the whole ticket has the best chance of hitting (about 45%+).'],
  ['VERY SECURE', 'bg-sky-500 text-black', 'Still strong, a step below a Lock (about 30–45% for the whole ticket to hit).'],
  ['SECURE', 'bg-zinc-600 text-white', 'Good picks, but the most risk of the three. Play smaller.'],
  ['🔥 HOT', 'bg-red-500 text-white', 'College only. Upset-proof: a big favorite, much better team, scores a lot more and has a winning record, so most checks pass.'],
  ['WARM', 'bg-amber-400 text-black', 'College only. Favored, but fewer of the upset-proof checks pass.'],
  ['❄ COLD', 'bg-sky-300 text-black', 'College only. Favored, but the least upset-proof. Highest risk of the college tickets.'],
];
const TERMS = [
  ['Safe 1, Safe 2…', 'Tickets ranked from most secure (Safe 1) down. No pick is repeated and each ticket has at most 2 picks from the same game.'],
  ['legs · avg · all-hit chance', 'Number of picks on the ticket, their average win %, and the chance that every single leg hits.'],
  ['Why it\'s safe', 'Tap it on any pick for the stats behind it: records, scoring, last games, matchup, weather and the model projection.'],
  ['Blowout Spreads', 'College favorites expected to win by a lot, with the spread line (for example MIA -21).'],
  ['College / NFL / NBA tabs', 'At the bottom, switch leagues to see every game this week, not just the ones on tickets. Tap a game for its picks.'],
  ['-21 (ML -1650)', 'Spread and moneyline. -21 means they must win by more than 21. ML -1650 means a heavy favorite to win outright.'],
];

// Plain-English key for every rating and section on Nick's Picks.
export default function PicksLegend() {
  const [open, setOpen] = useState(true);
  return (
    <div className="rounded-xl border border-amber-500/30 bg-zinc-900/70 p-3" data-testid="picks-legend">
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid="picks-legend-toggle"
        className="flex w-full items-center gap-2 text-sm font-bold text-amber-300">
        <Info className="w-4 h-4" />How to read these picks
        <ChevronDown className={`ml-auto w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="mt-3 grid gap-4 md:grid-cols-2">
          <div className="space-y-1.5" data-testid="picks-legend-ratings">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-zinc-500">Ticket ratings</p>
            {RATINGS.map(([k, tone, d]) => (
              <p key={k} className="text-xs text-zinc-300"><span className={`mr-1.5 rounded px-1.5 py-0.5 text-[9px] font-bold ${tone}`}>{k}</span>{d}</p>
            ))}
          </div>
          <div className="space-y-1.5" data-testid="picks-legend-terms">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-zinc-500">Sections & terms</p>
            {TERMS.map(([k, d]) => <p key={k} className="text-xs text-zinc-300"><b className="text-white">{k}:</b> {d}</p>)}
          </div>
        </div>
      )}
    </div>
  );
}
